export const TODOS_BASE_PATH = "/control-panel/todos";

export const TODO_FILTER_PARAMS = {
  query: "q",
  overdue: "late",
  people: "p",
  badges: "b",
} as const;

export const boardPath = (boardId: string): string =>
  `${TODOS_BASE_PATH}/${encodeURIComponent(boardId)}`;

export const taskPath = (boardId: string, shortId: string): string =>
  `${boardPath(boardId)}/${encodeURIComponent(shortId)}`;

/** "usr_7,usr_9" -> ["usr_7", "usr_9"], en ignorant les entrees vides. */
export const parseIdList = (raw: string | null): string[] =>
  (raw || "")
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);

/** L'inverse. Une liste vide rend une chaine vide, donc aucun parametre ecrit. */
export const serializeIdList = (ids: string[]): string =>
  ids.filter(Boolean).join(",");

/**
 * Forme comparable d'un short id. Le back sert des majuscules, un lien colle
 * peut arriver en minuscules : on compare toujours en majuscules.
 */
export const normalizeShortId = (value?: string | null): string =>
  (value || "").trim().toUpperCase();

/**
 * Forme affichee, "#AB12". Rend une chaine vide tant que le back ne sert pas
 * encore de short id, pour ne jamais afficher "#undefined".
 */
export const formatShortId = (value?: string | null): string => {
  const normalized = normalizeShortId(value);
  return normalized ? `#${normalized}` : "";
};

/** Lien absolu partageable vers une tache. */
export const absoluteTaskUrl = (boardId: string, shortId: string): string =>
  `${window.location.origin}${taskPath(boardId, shortId)}`;
